import React from "react"
import { Eyebrow, Headline, GridLines, Analytics } from "@shared"
import { css } from "@jsUtils"
import podcastImage from "@assets/images/podcast.png"
import podcastImage2x from "@assets/images/podcast@2x.png"
import podcastBadgeSpotify from "@assets/images/spotify-podcasts.png"
import podcastBadgeGoogle from "@assets/images/google-podcasts.png"
import podcastBadgeApple from "@assets/images/apple-podcasts.png"

import { PageSection } from "../PageSection"

import Styles from "./podcast.module.scss"

/**
 * Podcast section
 * @param {object} props - React props
 */
const Podcast = props => {
  const { color, theme } = props
  const [ready, setReady] = React.useState(false)
  const TrackedLink = Analytics("a")
  return (
    <PageSection
      className={css(Styles.section, Styles[`theme_${theme}`], ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>
        <div className={css(Styles.left, `podcastImageWrapperIEOverride`)}>
          <div className={css(Styles.imageWrapper)}>
            <img
              className={Styles.image}
              src={podcastImage}
              srcSet={`${podcastImage2x} 2x`}
              alt="Inside the Exo Chamber - Hosted by Andy + Greg - Follow Us Online: @TheExoEffect - Available On Spotify, iTunes, Anchor, and more!"
            />
          </div>
        </div>
        <div className={Styles.right}>
          <div className={Styles.copy}>
            <Eyebrow className={Styles.eyebrow} color={color}>
              Our Podcast
            </Eyebrow>
            <Headline className={Styles.headline} size={2}>
              The podcast you never knew you needed.
            </Headline>
            <p className={Styles.description}>
              Bringing you the insider perspective on our people, our startup adventure, and the
              world of medical imaging. Buy the merch.
            </p>
            <div className={Styles.badges}>
              <TrackedLink
                ascope="BADGES"
                adata="PODSPOTIFY"
                className={Styles.badge}
                target="_blank"
                rel="noopener noreferrer"
                href="https://open.spotify.com/show/2vGxOyz1NSkuOyw5lW4iPi?si=t81mikGQSSWVYxa0p0KJ1Q"
              >
                <img src={podcastBadgeSpotify} alt="Listen on Spotify Podcasts" />
              </TrackedLink>
              <TrackedLink
                ascope="BADGES"
                adata="PODGOOGLE"
                className={Styles.badge}
                target="_blank"
                rel="noopener noreferrer"
                href="https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8yOGEwMDgzNC9wb2RjYXN0L3Jzcw"
              >
                <img src={podcastBadgeGoogle} alt="Listen on Google Podcasts" />
              </TrackedLink>
              <TrackedLink
                ascope="BADGES"
                adata="PODAPPLE"
                className={Styles.badge}
                target="_blank"
                rel="noopener noreferrer"
                href="https://podcasts.apple.com/us/podcast/inside-the-exo-chamber/id1521021641"
              >
                <img src={podcastBadgeApple} alt="Listen on Apple Podcasts" />
              </TrackedLink>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default Podcast
